/* ==========================================================
   Veloura cart drawer — timer en verzendbescherming.

   Dawn tekent de drawer na elke wijziging opnieuw (innerHTML van
   #CartDrawer wordt vervangen). Dit script staat daarom BUITEN de
   drawer en werkt met gedelegeerde listeners plus een
   MutationObserver, zodat alles blijft werken na elke hertekening.

   - Timer: 10 minuten, loopt door tussen hertekeningen via
     sessionStorage (met try/catch: private mode mag niet breken).
   - Verzendbescherming: variant PROT_ID wordt standaard toegevoegd
     zodra er iets in de cart zit. Zet de klant de schakelaar uit,
     dan onthouden we dat voor de rest van de sessie.
   ========================================================== */

(function () {
  'use strict';

  var PROT_ID = 53148254765337;
  var DURATION = 600; /* seconden */
  var KEY_DEADLINE = 'ctrCartDeadline';
  var KEY_PROT_OFF = 'ctrProtOff';

  var busy = false;
  var lastAutoAdd = 0;

  /* ---------- sessionStorage, veilig ---------- */

  function sget(k) {
    try { return sessionStorage.getItem(k); } catch (e) { return null; }
  }
  function sset(k, v) {
    try { sessionStorage.setItem(k, v); } catch (e) { /* niets */ }
  }
  function sdel(k) {
    try { sessionStorage.removeItem(k); } catch (e) { /* niets */ }
  }

  /* ---------- Timer ---------- */

  function deadline() {
    var d = parseInt(sget(KEY_DEADLINE), 10);
    var now = Date.now();
    if (isNaN(d) || d <= now) {
      d = now + DURATION * 1000;
      sset(KEY_DEADLINE, String(d));
    }
    return d;
  }

  function tick() {
    var els = document.querySelectorAll('[data-ctr-timer]');
    if (!els.length) return;
    var left = Math.max(0, Math.round((deadline() - Date.now()) / 1000));
    if (left === 0) {
      /* Verlopen: stilletjes opnieuw beginnen. */
      sdel(KEY_DEADLINE);
      left = DURATION;
    }
    var m = Math.floor(left / 60);
    var s = left % 60;
    var txt = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== txt) els[i].textContent = txt;
    }
  }

  setInterval(tick, 1000);

  /* ---------- Drawer opnieuw ophalen na een cart-wijziging ---------- */

  function refreshDrawer() {
    return fetch(window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble'
      : '/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        /* Net als Dawn alleen .drawer__inner vervangen: de overlay en
           zijn klik-listener moeten blijven bestaan. */
        var cur = document.querySelector('#CartDrawer .drawer__inner');
        if (cur && sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('.drawer__inner');
          if (fresh) cur.innerHTML = fresh.innerHTML;
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var bfresh = bdoc.querySelector('.shopify-section');
          if (bfresh) bubble.innerHTML = bfresh.innerHTML;
        }
        tick();
      })
      .catch(function () { /* niets */ });
  }

  function cartPost(path, payload) {
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function addProt() {
    return cartPost('/cart/add.js', { items: [{ id: PROT_ID, quantity: 1 }] });
  }

  function removeProt() {
    var updates = {};
    updates[PROT_ID] = 0;
    return cartPost('/cart/update.js', { updates: updates });
  }

  /* ---------- Schakelaar ---------- */

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-ctr-prot-toggle')) return;
    if (busy) { e.preventDefault(); return; }
    busy = true;
    t.disabled = true;
    var turnOn = t.checked;
    var done = function () {
      refreshDrawer().then(function () {
        setTimeout(function () { busy = false; }, 150);
      });
    };
    if (turnOn) {
      sdel(KEY_PROT_OFF);
      addProt().then(done, done);
    } else {
      sset(KEY_PROT_OFF, '1');
      removeProt().then(done, done);
    }
  });

  /* ---------- Standaard aan: automatisch toevoegen ---------- */

  function ensureProt() {
    if (busy) return;
    var el = document.querySelector('[data-ctr-prot]');
    if (!el) return; /* lege cart: blok wordt niet gerenderd */

    var protQty = parseInt(el.getAttribute('data-prot-qty'), 10) || 0;
    var count = parseInt(el.getAttribute('data-count'), 10) || 0;

    if (count === 0 && protQty > 0) {
      /* Alleen de bescherming zit er nog in: cart echt leegmaken. */
      busy = true;
      removeProt().then(function () {
        refreshDrawer().then(function () {
          setTimeout(function () { busy = false; }, 150);
        });
      });
      return;
    }

    if (count > 0 && protQty === 0 && !sget(KEY_PROT_OFF)) {
      var now = Date.now();
      if (now - lastAutoAdd < 4000) return; /* nooit rondlopen */
      lastAutoAdd = now;
      busy = true;
      addProt().then(function () {
        refreshDrawer().then(function () {
          setTimeout(function () { busy = false; }, 150);
        });
      }, function () {
        busy = false;
      });
    }
  }

  /* ---------- Meekijken met hertekeningen van Dawn ---------- */

  function watch() {
    var root = document.querySelector('cart-drawer');
    if (!root || !('MutationObserver' in window)) return;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        tick();
        ensureProt();
      }, 120);
    }).observe(root, { childList: true, subtree: true });
  }

  function boot() {
    tick();
    ensureProt();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
